export default [
  {
    path: '/engine/modules/:moduleId/actions/:id',
    name: 'engine-action-edit',
    component: () => import('./editAction.vue'),
    props: route => ({ moduleId: route.params.moduleId, actionId: route.params.id, standalone: true }),
    meta: { engine: true, requiresAdmin: true },
  },
]
